import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDoubleCheckIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={10}
    fill="none"
    viewBox="0 0 16 10"
    {...props}
  >
    <path
      stroke="#111"
      strokeLinecap="round"
      strokeWidth={1.2}
      d="m1 5.41 2.783 3.27c.16.187.42.187.58 0l1.759-2.066M10.904 1 8.172 4.208"
    />
    <path
      stroke="#111"
      strokeLinecap="round"
      strokeWidth={1.2}
      d="M4.756 5.01 7.88 8.68c.16.187.42.187.58 0L15 1"
    />
  </svg>
);
export default SvgDoubleCheckIcon;
